const Loading: React.FC = () => {
  return <div data-testid="loading">Loading...</div>
}

export default Loading
